module.exports = __webpack_public_path__ + "img/recommendation.33abe8dc.svg";